import React from 'react';

import orqaLogoWithBackground from '../../../main/assets/images/wingcore/orqa-logo-with-background.webp';

export const LearnMore = () => {
  return (
    <section className="wingcore-learn-section">
      <div className="wingcore-learn-content">
        <h2 className="wingcore-learn-title">Learn More</h2>
        <p className="wingcore-learn-description">
          If you're looking for a dual-use, fully NDAA-compliant flight
          controller, you just found it. Get in touch to discuss your exact
          operational requirements.
        </p>
        <div className="dreamX__discover--button">
          <a
            href="/contact?product=h7-wingcore"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Contact us
          </a>
        </div>
      </div>
      <img
        src={orqaLogoWithBackground}
        alt="Company Orqa logo with background"
        className="wingcore-learn-product"
      />
    </section>
  );
};
